module.exports = __webpack_public_path__ + "static/grommet.8692b059.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/grommet.png
// module id = 847
// module chunks = 73261030922168